import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { Grid, Typography } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { CustomButton } from 'components/CustomButton'

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  headerTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
  },
  pageIndicator: {
    width: '4px',
    height: '24px',
    borderRadius: '2px',
    background: `linear-gradient(180deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
    marginRight: theme.spacing(1.5),
    flexShrink: 0,
  },
  titleTypography: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    fontSize: '1rem',
  },
  botao: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    fontWeight: 'bold',
    borderRadius: '8px',
    padding: '8px 20px',
    boxShadow: theme.shadows[1],
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  addIcon: {
    marginRight: theme.spacing(1),
  },
}))

export const Header = (props) => {
  const { className, titulo, linkBotao, textoBotao, linkRetorno, tituloLinkRetorno, ...rest } = props
  const classes = useStyles()

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Grid container>
        <Grid item xs={12} className={classes.headerTitleContainer} style={{ justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className={classes.pageIndicator} />
            <Typography component="h1" variant="h5" className={classes.titleTypography}>
              {titulo}
            </Typography>
          </div>
          
          {linkBotao && textoBotao ? (
            <div>
              <CustomButton
                component={RouterLink}
                to={{
                  pathname: linkBotao,
                }}
                className={classes.botao}
                variant="contained"
              >
                <AddIcon className={classes.addIcon} />
                {textoBotao}
              </CustomButton>
            </div>
          ) : null}
        </Grid>
      </Grid>
    </div>
  )
}
